import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickHelpComplianceStatusComponent } from './quick-help-compliance-status.component';
import { QuickHelpTranslationsComponent } from '../pagedetails/details/sections/seo/seo-information/sections/quick-help/translations/translations.component';
import { AccessibilityDashboardDistributionProgressBarComponent } from '../../pages/accessibility/dashboard/distribution/progress-bar/progress-bar.component';
import { LayoutModule } from '@monsido/angular-shared-components';
import { IconsModule } from '@layout/icons/icons.module';
import { MonNumberPipe } from '@monsido/core/locale/pipes/mon-number.pipe';
import { TranslateModule } from '@client/app/modules/translate.module';


@NgModule({
    declarations: [
        QuickHelpComplianceStatusComponent,
        AccessibilityDashboardDistributionProgressBarComponent,
    ],
    imports: [
        CommonModule,
        LayoutModule,
        IconsModule,
        MonNumberPipe,
        TranslateModule,
        QuickHelpTranslationsComponent,
    ],
    exports: [
        QuickHelpComplianceStatusComponent,
        QuickHelpTranslationsComponent,
        AccessibilityDashboardDistributionProgressBarComponent,
    ],
})
export class QuickHelpComplianceStatusModule {}
